import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  ReportsJournalSelect,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect, 
  VendorSelect
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
// import { toWords } from "number-to-words";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

export default function CheckVoucher() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
//#endregion






//#region Journal 
  const AP_DOCUMENT_TYPE = 1;
  const [journal, setJournal] = useState(null);
  const [vendor, setVendor] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [amount, setAmount] = useState(null);
  const [company, setCompany] = useState(null);
  const [showJournalSelect, setShowJournalSelect] = useState(false);

  const openJournalSelect = () => {
    setShowJournalSelect(true)
  }
  const closeJournalSelect = () => {
    setShowJournalSelect(false)
  }
//#endregion




  const [showVendorSelect, setShowVendorSelect] = useState(false);

  const openVendorSelect = () => {
    setShowVendorSelect(true)
  }
  const closeVendorSelect = () => {
    setShowVendorSelect(false)
  }








//#region Generate
  const fetchReportData = useCallback(async () => {
    const _data = {
      vendorId: vendor?.vendorId || null,
      dateFrom: dateFrom || null,
      dateTo: dateTo || null,
      documentId: journal?.id || null,
      amount: amount || null,
    }

    try {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/check-voucher`, _data, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [vendor, dateFrom, dateTo, amount, journal]);

  const generateHandleClick = async () => {
    if (!company || !vendor) {
      setFailMessage("Please fill up required fields");
      return;
    }

    setLoading(true);

    try {
      const _data = await fetchReportData();

      console.log({_data})
      if(_data.length === 0){
        setFailMessage("No data found");
        return;
      }

      const today = new Date().toISOString().split("T")[0];

      // 1. Load the template PDF once to use as a source
      const pdfUrl = `${window.location.origin}/docs/CHECK_VOUCHER_3.pdf`;
      const response = await fetch(pdfUrl);
      const templateBytes = await response.arrayBuffer();
      const templateDoc = await PDFDocument.load(templateBytes);

      // 2. Create the main PDF document where we will add pages
      const pdfDoc = await PDFDocument.create();
      pdfDoc.registerFontkit(fontkit);

      // Load fonts
      const fontBytes = await (await fetch("/calibri.ttf")).arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);
      const boldBytes = await (await fetch("/calibrib.ttf")).arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      // Helper: Wrap Text
      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const tokens = text.match(/[^,\s/\\-]+[,\s/\\-]*/g) || [text];
        const lines = [];
        let currentLine = "";
        for (const token of tokens) {
          const testLine = currentLine + token;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine.trimEnd());
            currentLine = token;
          }
        }
        if (currentLine) lines.push(currentLine.trimEnd());
        return lines;
      };

      // --- MAIN LOOP: Iterate through each record in _data ---
      for (const itemData of _data) {
        let currentPage;
        let yPosition = 520;
        const bottomMargin = 120; // Point where we trigger a new page
        const lineHeight = 12;

        // Function to add a new page based on template and draw headers
        const addNewPage = async () => {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          const newPage = pdfDoc.addPage(templatePage);

          // Header Info (Drawn on every new page for this voucher)
          newPage.drawText(company.name?.toString() ?? "", { x: 25, y: 741, size: 16, font: calibriBold });
          newPage.drawText(company.address?.toString() ?? "", { x: 25, y: 731, size: 10, font: calibriFont });
          newPage.drawText(company.tin?.toString() ?? "", { x: 25, y: 721, size: 10, font: calibriFont });
          newPage.drawText(itemData?.referenceNumber?.toString() ?? "", { x: 460, y: 655, size: 10, font: calibriBold });
          newPage.drawText(vendor?.name?.toString() ?? "", { x: 80, y: 611, size: 10, font: calibriBold });
          newPage.drawText(FormatDateToMDY(today), { x: 390, y: 611, size: 10, font: calibriBold });

          return newPage;
        };

        // Initialize the first page for this itemData
        currentPage = await addNewPage();

        // Loop through references for the current voucher
        for (const ref of itemData?.reference || []) {
          // Prepare text content
          let particulars = ref?.particulars?.length > 0
            ? ref.particulars.map(p => `${p.itemCode} - ${p.itemDescription} Qty: ${p.receivedQty}`).join(', ')
            : "No items received";

          if (itemData?.documentSubType === "Expense") {
            particulars = ref?.particulars?.length > 0
              ? ref.particulars.map(p => p.accountName).join(', ')
              : "No items received";
          }

          const docRefLines = wrapText(ref.referenceNumber?.toString() || "", 150, calibriFont, 9);
          const docNoLines = wrapText(particulars, 300, calibriFont, 9);
          const maxLines = Math.max(docRefLines.length, docNoLines.length + 1); // +1 because we offset the second block

          // CHECK FOR OVERFLOW: If content doesn't fit, create a new page
          const requiredHeight = (maxLines * lineHeight) + 20;
          if (yPosition - requiredHeight < bottomMargin) {
            currentPage = await addNewPage();
            yPosition = 520; // Reset Y to top of table area
          }

          for (let j = 0; j < docRefLines.length; j++) {
            const line = docRefLines[j];
            currentPage.drawText(line, { 
              x: 40, 
              y: yPosition - (j * lineHeight), 
              size: 10, 
              font: calibriFont 
            });
          }

          // Replace docNoLines.forEach with a standard for loop
          for (let j = 0; j < docNoLines.length; j++) {
            const line = docNoLines[j];
            currentPage.drawText(line, { 
              x: 40, 
              y: (yPosition - 12) - (j * lineHeight), 
              size: 10, 
              font: calibriFont 
            });
          }

          // Draw Amount
          currentPage.drawText(FormatValueToDecimal(ref.amountPaid)?.toString() ?? "0.00", {
            x: 460,
            y: yPosition - 12,
            size: 10,
            font: calibriFont
          });

          yPosition -= requiredHeight;
        }

        currentPage.drawText(`${itemData?.bankName || ""}`, {
          x: 450,
          y: 200, // Adjust based on your template's "Total" area
          size: 10,
          font: calibriBold
        });
        currentPage.drawText(`${itemData?.checkbookNumber || ""}`, {
          x: 450,
          y: 185, // Adjust based on your template's "Total" area
          size: 10,
          font: calibriBold
        });
        currentPage.drawText(`${FormatDateToMDY(itemData?.checkbookDate)}`, {
          x: 450,
          y: 170, // Adjust based on your template's "Total" area
          size: 10,
          font: calibriBold
        });

        const _totalAmount = (itemData.totalAmount ?? 0) - (itemData.totalEWT ?? 0);
        currentPage.drawText(`${FormatValueToDecimal(_totalAmount)}`, {
          x: 450,
          y: 155, // Adjust based on your template's "Total" area
          size: 10,
          font: calibriBold
        });

        // Draw Totals for this voucher (at the end of the last page of this item)
        // Note: You might want to position this at a fixed footer instead
        // currentPage.drawText(`Total: ${FormatValueToDecimal(voucherTotalAmount)}`, {
        //   x: 460,
        //   y: 80, // Adjust based on your template's "Total" area
        //   size: 11,
        //   font: calibriBold
        // });
      }

      // 3. Save and Download
      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Check_Vouchers_${today}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    } finally {
      setLoading(false);
    }
  };


//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasOutgoingPaymentVoucher) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl calibriFont-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Check Voucher`}
            </h2>
            <p className="text-gray-500 mt-1">An accounting document/report that records and summarizes a payment made.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Vendor <span className="text-red-500">*</span>
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Vendor"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                readOnly
              />
              {!vendor ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelect}>
                  <PersonSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm calibriFont-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm calibriFont-medium mb-1 text-gray-700 ">
              Transaction
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Transaction"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${journal ? `${journal?.documentHeaderText} - ${journal?.company?.companyName1} - ${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(journal?.totalDebitAmount)}` : ""}`}
                readOnly
              />
              {!journal ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openJournalSelect}>
                  <ManageSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setJournal(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm calibriFont-medium mb-1 text-gray-700 ">
              Amount
            </label>
            <div className="flex flex-row items-center">
              <input
                type="number"
                placeholder="0"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={amount || 0}
                onChange={(e)=> setAmount(e.target.value)}
              />
            </div>
            <span className="font-semibold text-gray-400 italic">
              {`${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(amount)}`}
            </span>
          </div>
        </div>

        <button onClick={generateHandleClick} className="mt-10 flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm calibriFont-semibold hover:bg-theme-color-h transition shadow-md">
          <RestartAltIcon fontSize="small" /> Generate
        </button>
      </div>

      <VendorSelect 
        visible={showVendorSelect} 
        onClose={closeVendorSelect}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />

      <ReportsJournalSelect 
        visible={showJournalSelect} 
        onClose={closeJournalSelect}
        modalName={"Select Transaction"}
        documentTypeId={AP_DOCUMENT_TYPE}
        data={journal} setData={setJournal}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}